import { render, staticRenderFns } from "./ContactoView.vue?vue&type=template&id=742b92dc&scoped=true&"
import script from "./ContactoView.vue?vue&type=script&lang=ts&"
export * from "./ContactoView.vue?vue&type=script&lang=ts&"
import style0 from "./ContactoView.vue?vue&type=style&index=0&id=742b92dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742b92dc",
  null
  
)

export default component.exports